/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * A layout container div component which
 * will automatically expand and fill the
 * space that it's been given.
 *
 * @param {object} props See propTypes
 * @returns {Fill} The Fill component
 */
var Fill = function Fill(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, children);
};
Fill.propTypes = {
  /**
   * Any React children of this container
   */
  children: _propTypes["default"].any
};
var _default = Fill;
exports["default"] = _default;